import React, { useContext, useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import ToggleButton from "./ui/ToggleButton.tsx";
import Logo from "../images/logo.svg";
import { Button } from "./ui/button.tsx";
import { ContextApp } from "../utils/Context.jsx";
import { ThemeContext } from "./ThemeContext";
import FileManagementModal from "./modal/FileManagementModal.tsx";
import WhatsAppMenuModal from "./modal/WhatsAppMenuModal.tsx";
import UserManagementModal from "./modal/UserManagementModal.tsx";
import ServiceMenuModal from "./modal/ServiceMenuModal.tsx";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    setIsGuest,
    setIsLoggedIn,
    isLoggedIn,
    isGuest,
    isSidebarCollapsed,
    userRole,
  } = useContext(ContextApp);
  const { isDarkMode } = useContext(ThemeContext);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [showFileManagementModal, setShowFileManagementModal] = useState(false);
  const [showWhatsAppMenuModal, setShowWhatsAppMenuModal] = useState(false);
  const [showUserManagementModal, setShowUserManagementModal] = useState(false);
  const [showServiceMenuModal, setShowServiceMenuModal] = useState(false);
  const [showProfileManagementModal, setShowProfileManagementModal] =
    useState(false);

  const handleLogout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("expirationDate");
    Cookies.remove("refreshToken");
    setIsLoggedIn(false);
    setIsGuest(false);
    navigate("/login");
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    window.location.reload();
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header
      className={`relative flex justify-between items-center md:px-8 pr-1 pl-1 pb-0 mb-4 py-6 mr-1 md:mr-12 text-primary ${
        isDarkMode ? "bg-transparent dark:bg-transparent" : "bg-transparent"
      }`}
    >
      <div
        className="flex items-center cursor-pointer transform transition-transform duration-300 hover:scale-110"
        onClick={handleLogoClick}
      >
        <img
          src={Logo}
          alt="Logo"
          className="h-16 w-16 transition-all duration-300 hover:brightness-110"
        />
      </div>
      <div
        className={`flex items-center gap-4 transition-all duration-300 ${
          isSidebarCollapsed ? "mr-16" : "sm:mr-[320px] mr-0"
        }`}
      >
        <ToggleButton />
        {location.pathname !== "/login" && (
          <>
            {isLoggedIn ? (
              <>
                <div className="relative left-0" ref={dropdownRef}>
                  <button
                    className="flex items-center justify-center w-10 h-10 rounded-full bg-green-100 text-black font-bold text-lg cursor-pointer hover:shadow-md"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    A
                  </button>
                  {showDropdown && (
                    <div className="absolute right-0 mt-2 w-56 bg-neutral-900 text-white rounded-lg shadow-lg z-50 border border-gray-700">
                      <ul className="flex flex-col divide-y divide-gray-600">
                        {userRole === "admin" && (
                          <>
                            <li
                              className="px-4 py-2 hover:bg-neutral-800 cursor-pointer transition"
                              onClick={() => {
                                setShowUserManagementModal(true);
                                setShowDropdown(false);
                              }}
                            >
                              Administración de Usuario
                            </li>
                            <li
                              className="px-4 py-2 hover:bg-neutral-800 cursor-pointer transition"
                              onClick={() => {
                                setShowFileManagementModal(true);
                                setShowDropdown(false);
                              }}
                            >
                              Administración de Archivos
                            </li>
                            <li
                              className="px-4 py-2 hover:bg-neutral-800 cursor-pointer transition"
                              onClick={() => {
                                setShowWhatsAppMenuModal(true);
                                setShowDropdown(false);
                              }}
                            >
                              Servicio de WhatsApp
                            </li>
                            {/*<li
                              className="px-4 py-2 hover:bg-neutral-800 cursor-pointer transition"
                              onClick={() => {
                                setShowServiceMenuModal(true);
                                setShowDropdown(false);
                              }}
                            >
                              Estado de la Aplicación
                            </li> */}
                          </>
                        )}
                        <li
                          className="px-4 py-2 hover:bg-neutral-800 cursor-pointer transition"
                          onClick={() => {
                            setShowProfileManagementModal(true);
                            setShowDropdown(false);
                          }}
                        >
                          Administración Perfil
                        </li>
                        <li
                          className="px-4 py-2 hover:bg-neutral-800 cursor-pointer transition"
                          onClick={handleLogout}
                        >
                          Cerrar sesión
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                <div className="block">
                  <Button
                    variant="primary"
                    onClick={handleLogout}
                    className="bg-red-500 text-white hover:bg-red-600 px-4 py-2 rounded-md text-sm leading-none"
                  >
                    Cerrar Sesión
                  </Button>
                </div>
              </>
            ) : (
              <>
                {!isGuest && (
                  <Button variant="secondary" onClick={() => setIsGuest(true)}>
                    Invitado
                  </Button>
                )}
                <Button variant="primary" onClick={() => navigate("/login")}>
                  Iniciar Sesión
                </Button>
              </>
            )}
          </>
        )}
      </div>
      {showFileManagementModal && (
        <FileManagementModal
          onClose={() => setShowFileManagementModal(false)}
          isOpen={showFileManagementModal}
        />
      )}

      {showWhatsAppMenuModal && (
        <WhatsAppMenuModal
          onClose={() => setShowWhatsAppMenuModal(false)}
          isOpen={showWhatsAppMenuModal}
        />
      )}

      {showUserManagementModal && (
        <UserManagementModal
          onClose={() => setShowUserManagementModal(false)}
          isOpen={showUserManagementModal}
        />
      )}

      {showServiceMenuModal && (
        <ServiceMenuModal
          onClose={() => setShowServiceMenuModal(false)}
          isOpen={showServiceMenuModal}
        />
      )}
    </header>
  );
};

export default Header;
